import { SCREEN_FIELD, UNSCREEN_FIELD } from '../actions/screen'

export default (state = [], action) => {
    switch (action.type) {
        case SCREEN_FIELD:
            return [...state, action.field]

        case UNSCREEN_FIELD:
            return state.filter(f => f !== action.field)

        default:
            return state
    }
}
